import React from 'react';
import { useIntl } from 'react-intl';
import './styles.scss';

const TimeOfDayEVDetails = () => {
  const intl = useIntl();
  return (
    <div>
      <div className="subtitle">
        {intl.formatMessage({
          id: 'rs.timeOfDayEV',
          defaultMessage: 'Time-of-Day rate (5-8 p.m.) with EV rate discount',
        })}
      </div>

      <div className="text">
        {intl.formatMessage(
          {
            id: 'rs.timeOfDayEV.body',
            defaultMessage:
              'By registering your EV on MyAccount, EV drivers can receive an additional 1.5¢ discount on all electric usage between midnight and 6 AM.',
          },
          { br: <br /> }
        )}
      </div>
    </div>
  );
};

export default TimeOfDayEVDetails;
